const MERCHANT_SITE_URL =
  import.meta.env.VITE_FIREBASE_PROJECT_ID === "disco-fb-pro"
    ? "https://merchant.disca.app"
    : "https://merchant-disca-sta.web.app";

export function merchantDashboardUrl(storeId: string, ssoToken?: string): string {
  const base = `${MERCHANT_SITE_URL}/${storeId}`;
  return ssoToken ? `${base}?sso_token=${encodeURIComponent(ssoToken)}` : base;
}
